export default function Taxation() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Fiscalidad del Nómada Digital
            </h2>
            <p className="text-xl text-gray-700">
              Optimiza tus impuestos según tu situación laboral
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white rounded-2xl shadow-xl p-8">
              <div className="w-16 h-16 flex items-center justify-center bg-blue-600 rounded-full mb-6">
                <i className="ri-building-fill text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                A) Si eres empleado
              </h3>
              <p className="text-lg text-gray-700 mb-6">
                Puedes acogerte a la <strong>Ley Beckham</strong>, un régimen fiscal especial que te permite:
              </p>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <div>
                    <p className="text-lg text-gray-800">
                      Ser considerado <strong>no residente fiscal</strong>
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-2xl text-green-600 mt-1"></i>
                  <div>
                    <p className="text-lg text-gray-800">
                      Pagar un <strong>IRPF fijo del 24%</strong>
                    </p>
                    <p className="text-sm text-gray-600">(en lugar del progresivo que alcanza el 48%)</p>
                  </div>
                </div>
              </div>
              <div className="mt-6 bg-blue-50 rounded-lg p-4 border-l-4 border-blue-600">
                <p className="text-sm font-semibold text-gray-900">
                  💰 Ahorro fiscal significativo con la Ley Beckham
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-8">
              <div className="w-16 h-16 flex items-center justify-center bg-green-600 rounded-full mb-6">
                <i className="ri-user-star-fill text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                B) Si eres autónomo
              </h3>
              <p className="text-lg text-gray-700 mb-6">
                Debes tributar como residente:
              </p>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <i className="ri-money-dollar-circle-fill text-2xl text-blue-600 mt-1"></i>
                  <div>
                    <p className="text-lg text-gray-800">
                      <strong>Cuota mensual Seguridad Social:</strong>
                    </p>
                    <p className="text-gray-600">80 € a 500 € según ingresos</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-file-text-fill text-2xl text-blue-600 mt-1"></i>
                  <div>
                    <p className="text-lg text-gray-800">
                      Declaración trimestral y anual del IRPF
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-calculator-fill text-2xl text-blue-600 mt-1"></i>
                  <div>
                    <p className="text-lg text-gray-800">
                      Declaración trimestral de IVA
                    </p>
                  </div>
                </div>
              </div>
              <div className="mt-6 bg-green-50 rounded-lg p-4 border-l-4 border-green-600">
                <p className="text-sm font-semibold text-gray-900">
                  📊 Te ayudamos con toda la gestión fiscal
                </p>
              </div>
            </div>
          </div>

          {/* Moved to BeckhamCalculator component */}

        </div>
      </div>
    </section>
  );
}
